import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseCustomFieldViewComponent } from '../../../../../base/form';
import { ApiService } from '../../../../../services/api.service';
import { ViewService } from '../../../../../services/view.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { AssetTypeVariant } from '../../types';
import { arr_map, blank, data_get, filled, observe } from '../../../../../shared/utils/common';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'asset-types-view-variants',
  template: `
    <div fieldmagicGridRow>
      <div fieldmagicGridColumn="12">
        <table class="table table-bordered">
          <thead>
            <tr>
              <td width="30%">
                <fieldmagic-text
                  content="Variant"
                  purpose="table-header"
                >
                </fieldmagic-text>
              </td>
              <td width="40%">
                <fieldmagic-text
                  content="Description"
                  purpose="table-header"
                >
                </fieldmagic-text>
              </td>
              <td width="30%">
                <fieldmagic-text
                  content="Linked Product"
                  purpose="table-header"
                >
                </fieldmagic-text>
              </td>
            </tr>
          </thead>

          <tbody>
            <ng-container *ngIf="fetching$ | async">
              <tr class="text-center">
                <td colspan="3">
                  <fieldmagic-icon [spin]="true"></fieldmagic-icon>
                </td>
              </tr>
            </ng-container>

            <ng-container *ngIf="! (fetching$ | async)">
              <ng-container *ngIf="variants$ | async as variants">
                <tr
                  *ngIf="variants | blank"
                  class="text-center"
                >
                  <td colspan="3">No variants available.</td>
                </tr>

                <ng-container *ngFor="let variant of variants; let index = index">
                  <tr>
                    <td>{{ variant.name }}</td>
                    <td>{{ variant.description | placeholdWithString }}</td>
                    <td>
                      <ng-container
                        [ngTemplateOutlet]="itemDisplayTmp"
                        [ngTemplateOutletContext]="{
                          variant: variant
                        }"
                      >
                      </ng-container>
                    </td>
                  </tr>

                  <ng-container *ngIf="variant.sub_variants | filled">
                    <tr *ngFor="let sub_variant of variant.sub_variants;">
                      <td>
                        <fieldmagic-indent>
                          <span>{{ sub_variant.name }}</span>
                        </fieldmagic-indent>
                      </td>
                      <td>{{ sub_variant.description | placeholdWithString }}</td>
                      <td>
                        <ng-container
                          [ngTemplateOutlet]="itemDisplayTmp"
                          [ngTemplateOutletContext]="{
                            variant: sub_variant
                          }"
                        >
                        </ng-container>
                      </td>
                    </tr>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>

    <ng-template
      #itemDisplayTmp
      let-variant="variant"
    >
      <fieldmagic-text-link
        [segments]="(variant.item_text | filled) ? ['/items', variant.item_id] : []"
        [label]="variant.item_text"
        [openNewTab]="true"
      >
      </fieldmagic-text-link>
    </ng-template>
  `
})
export class AssetTypeViewVariantsComponent extends BaseCustomFieldViewComponent implements OnInit, OnDestroy {
  readonly fetching$ = new BehaviorSubject<boolean>(true);
  readonly variants$ = new BehaviorSubject<AssetTypeVariant[]>([]);

  private _onFetchingVariantsSubscription?: Subscription;

  constructor(
    private readonly _api: ApiService,
    private readonly _view: ViewService,
  ) {
    super();
  }

  ngOnInit(): void {
    const id = data_get(this._view.getViewRecord(), 'id');

    if (blank(id)) {
      this.fetching$.next(false);
    } else {
      this._onFetchingVariantsSubscription = observe({
        after: () => this.fetching$.next(false),
        observable: () => this._api.callPrivate$({
          path: '/asset_types/variants',
          action: 'post',
          body: {
            'asset_type_id': id,
          },
          onSuccessResponse: (response) => arr_map(response.get('items'), {
            transformer: (variant) => ({
              ... variant,
            })
          }),
        }),
      })
      .pipe(
        filter(filled)
      )
      .subscribe((variants) => this.variants$.next(variants));
    }
  }

  ngOnDestroy(): void {
    if (this._onFetchingVariantsSubscription) {
      this._onFetchingVariantsSubscription.unsubscribe();
    }
  }
}